export default __webpack_public_path__ + "static/media/14.0d20ef8c.png";